import React from "react";
import SecretariatTab from "./secretariatTab";
import {
  AiOutlineFolderOpen,
  AiOutlineContacts,
  AiOutlineNotification,
  AiOutlineCalendar,
} from "react-icons/ai";
import { useHistory } from "react-router-dom";
import TopNav from "../../components/TopNav";

export default function Index() {
  const history = useHistory();
  return (
    <div className="pb-28">
      <div className="doc_processing_color h-40 px-2 pt-3">
        <TopNav link={"/dashboard/user/home"} />
        <div className="text-lg">
          Welcome to the <br />
          <span className="text-4xl text-green-800 transcript_header">
            Secretariat
          </span>
        </div>
        <div className="text-lg">What would you like to get started with?</div>
      </div>
      <div className="px-4 pt-6">
        <SecretariatTab
          link={"/dashboard/user/document-processing"}
          icon={
            <AiOutlineFolderOpen size={20} color="#D5B354" className="mr-2" />
          }
          name={"Doc Processing/Order"}
          desc={"Certificate, English Waiver, Recommendation Letter etc."}
        />
        <SecretariatTab
          link={"/dashboard/user/member-directory"}
          icon={
            <AiOutlineContacts size={20} color="#D5B354" className="mr-2" />
          }
          name={"Member Directory"}
          desc={"Contact Information of Members and Leads to Direct Messaging"}
        />
        <SecretariatTab
          link={"/dashboard/user/announcements"}
          icon={
            <AiOutlineNotification size={20} color="#D5B354" className="mr-2" />
          }
          name={"Notice/Announcements"}
          desc={"General Notice to all Alumni"}
        />
        <SecretariatTab
          link={"/dashboard/user/careers"}
          icon={
            <AiOutlineCalendar size={20} color="#D5B354" className="mr-2" />
          }
          name={"Career HUB"}
          desc={"Job Opportunities, Scholarships"}
        />
        <SecretariatTab
          link={"/dashboard/user/faq-session"}
          icon={
            <AiOutlineCalendar size={20} color="#D5B354" className="mr-2" />
          }
          name={"FAQ"}
          desc={"Get Insight to Question You Need"}
        />
      </div>
      {/* <BottomNavBar /> */}
    </div>
  );
}
